// src/components/ui/PageHeader.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';

const PageHeader = ({ title, description, actions, showBreadcrumb = false }) => {
  const location = useLocation();

  // Define navigation mapping for consistent menu names
  const navigationMapping = {
    '/': {
      title: 'Home',
      description: 'Welcome to Mervo workforce management platform'
    },
    '/job-management': {
      title: 'Job Management',
      description: 'Create and manage jobs for your workforce'
    },
    '/workforce-management': {
      title: 'Workforce Management',
      description: 'Manage employees and contractors'
    },
    '/contractor/dashboard': {
      title: 'Contractor Dashboard',
      description: 'View your jobs, earnings, and schedule'
    },
    '/corporate/dashboard': {
      title: 'Corporate Dashboard',
      description: 'Manage your company\'s workforce and jobs'
    },
    '/super-admin/dashboard': {
      title: 'Super Admin Dashboard',
      description: 'System-wide management and monitoring'
    }
  };

  // Get current page info
  const currentPageInfo = navigationMapping?.[location?.pathname] || {
    title: title || 'Mervo',
    description: description || ''
  };

  // Use provided props or fall back to mapped values
  const pageTitle = title || currentPageInfo?.title;
  const pageDescription = description || currentPageInfo?.description;

  return (
    <div className="mb-8">
      {/* Page Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between">
        <div className="mb-4 md:mb-0">
          <h1 className="text-2xl sm:text-2xl lg:text-2xl xl:text-2xl font-bold text-text-primary mb-2">
            {pageTitle}
          </h1>
          {pageDescription && (
            <p className="text-text-secondary">
              {pageDescription}
            </p>
          )}
        </div>

        {/* Action Buttons */}
        {actions && (
          <div className="flex items-center space-x-3">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;